module.exports = __webpack_public_path__ + "fonts/mallorymp-bold-webfont.faf3e2cc445ff681c6615ffb0d09db7f.woff2";